import Component from './VirtualizedTree.component';

export default Component;
